import { render, staticRenderFns } from "./LabelSelector.vue?vue&type=template&id=cc27f4c6"
import script from "./LabelSelector.vue?vue&type=script&lang=js"
export * from "./LabelSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports